module.exports = __webpack_public_path__ + "img/neo-card.491127b8.png";